'use client';

import React from 'react';
import DynamicTabs from '@components/DynamicTabs';
import { Box, Stack } from '@mui/material';
import CommonContainer from '@components/CommonContainer';
import AlGhadeerTabData from './AlGhadeerTabData';
import cn from './style.module.scss';

export default function AlGhadeerSpecification(props: any) {
  const specificationSection = props.locale.section?.find(
    (section: any) => section.type === 'specification' && section.enabled
  );

  const tabs = specificationSection?.alghadeerSpecificationData?.map(
    (item: any, index: number) => ({
      title: item.tabButton,
      content: (
        <AlGhadeerTabData
          index={index}
          heading={item.tabTitle as string}
          description={item.tabDescription as string}
          images={item.images}
        />
      ),
    })
  );

  return (
    <Stack className={cn.alghadeerSpecificationWrapper} component="section">
      <CommonContainer
        paddingInline={{ xs: '0', sm: '32px', md: '24px' }}
        maxWidth={{ xs: '100%', md: '1200px', lg: '1400px' }}
        flexGrow={1}
      >
        <Box className={cn.alghadeerSpecificationBlock}>
          <DynamicTabs
            tabs={tabs}
            className={cn.alghadeerSpecificationTabs}
            elementClass={cn.alghadeerSpecificationTabsElement}
            tabClass={cn.alghadeerSpecificationTabsBlock}
            listClassName={cn.alghadeerSpecificationTabsList}
            contentClass={cn.alghadeerSpecificationTabsContent}
            activeClassName={cn.alghadeerSpecificationTabsActive}
          />
        </Box>
      </CommonContainer>
    </Stack>
  );
}
